import React from 'react';
import { Heading } from '@99designs/emu';
import { useOnboarder } from '../../Onboarder/OnboarderContext';
import { useOnboarderNav } from '../../Onboarder/useOnboarderNav';
import type { GenericStepData } from '../../Onboarder/Config';

export function StepHeader() {
    const onboarderNav = useOnboarderNav();
    const { data } = useOnboarder<GenericStepData>();
    const { Heading: StepHeading } = onboarderNav.currentStep();

    return (
        <Heading appearanceLevel={2} accessibilityLevel={1}>
            <StepHeading data={data} />
        </Heading>
    );
}
